import globalWindow from '@shared/core/globals';
import { useEffect, useState } from 'react';

/**
 * Load Google Fonts via WebFontLoader.
 *
 * @param fonts - Array of font family names to load
 * @returns `true` when font(s) have loaded, `false` while loading
 *
 * @example
 * // Basic usage - load fonts
 * useLoadGoogleFont(['Inter', 'PT Serif']);
 *
 * @example
 * // With loading state
 * const isLoaded = useLoadGoogleFont(['Inter']);
 * if (!isLoaded) return <Skeleton />;
 */
export const useLoadGoogleFont = (fonts: string[]): boolean => {
  const [active, setActive] = useState(false);

  useEffect(() => {
    if (fonts.length === 0) return;

    globalWindow.WebFont?.load({
      google: {
        families: fonts,
      },
      fontactive: () => setActive(true),
    });
    // Each font string is individually a dependency to avoid array reference issues
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, fonts);

  return active;
};

export default useLoadGoogleFont;
